import type {
  ExceptionPendingAction,
  ReversalOutcome
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'

/**
 * A excepcionalidade tem uma reversão multi-etapa aguardando votos.
 *
 * Gate duplo: flag do motor de aprovação no front + `pendingAction` vindo do
 * back. Backend antigo não manda o campo, e o comportamento fica o de hoje.
 */
export function isReversalPending(
  item: { pendingAction?: ExceptionPendingAction | null } | null | undefined,
  enabledApprovalEngine: boolean
): boolean {
  return enabledApprovalEngine && item?.pendingAction === 'REVERSAL'
}

/** Toast de sucesso de um VOTO na reversão (aprovar/recusar), por `outcome`. */
export const REVERSAL_VOTE_TOASTS: Record<ReversalOutcome, string> = {
  PENDING: 'Sua decisão foi registrada. Aguardando demais validadores.',
  REVERTED: 'Reversão realizada com sucesso!',
  REVERSAL_REJECTED: 'Reversão recusada. A excepcionalidade continua aprovada.'
}
